import React from 'react'
import { toast } from 'react-toastify'

const MobileNotAllowed = () => {
    return (
        <div className='w-full h-[100vh] relative flex items-center justify-center  overflow-x-hidden overflow-y-hidden bg-theme'>
            <span className='w-full shadow-xl text-center px-8 py-2 bg-white rounded text-theme font-bold'>
                Mobile Not Allowed
            </span>

            {/* <span className='w-full shadow-lg absolute bottom-30 -left-20 text-center rotate-45 px-8 py-2 bg-white rounded text-theme font-bold'>
                Use Desktop / Laptop
            </span> */}
        </div>
    )
}

export default MobileNotAllowed